import { Stack, Typography } from '@mui/material';
import { type ReactNode, useState } from 'react';

import { FSToggleButtonGroup } from '@/ui/components/button/FSToggleButtonGroup';
import { FSModal } from '@/ui/components/modal/FSModal';
import { FSModalTitle } from '@/ui/components/modal/FSModalTitle';
import { translate } from '@/ui/i18n';

import { OrganisationSection } from './sections/OrganisationSection';
import { PreferencesSection } from './sections/PreferencesSection';

export function ModalSettings({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <FSModal open={open} onClose={handleClose} maxWidth={600} showCloseButton>
      <Stack sx={{ gap: 3 }}>
        <FSModalTitle title={translate('Settings.settings-modal-name')} />
        <TabsAndContent />
      </Stack>
    </FSModal>
  );
}

function TabsAndContent() {
  const [activeSection, setActiveSection] =
    useState<SettingsSection>('my-organisation');

  const tabs = prepareTabValues();

  return (
    <>
      <FSToggleButtonGroup
        selectedValueId={activeSection}
        values={tabs}
        onChange={(id) => setActiveSection(id as SettingsSection)}
      />
      {activeSection === 'my-organisation' && <OrganisationSection />}
      {activeSection === 'preferences' && <PreferencesSection />}
    </>
  );
}

type SettingsSection = 'my-organisation' | 'preferences';

function prepareTabValues(): { id: SettingsSection; value: ReactNode }[] {
  return [
    {
      id: 'my-organisation',
      value: (
        <Typography sx={{ fontSize: '1rem' }}>
          {translate('EditOrganisation.my-organisation')}
        </Typography>
      ),
    },
    {
      id: 'preferences',
      value: (
        <Typography sx={{ fontSize: '1rem' }}>
          {translate('Settings.Preferences.preferences')}
        </Typography>
      ),
    },
  ];
}
